"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderCodeInfo = void 0;
const enum_1 = require("./enum");
exports.ProviderCodeInfo = {
    [enum_1.ProviderCode.AHTC]: {
        providerName: "Aljunied-Hougang Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.AMKTC]: {
        providerName: "Ang Mo Kio Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.BTPTC]: {
        providerName: "Bishan-Toa Payoh Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.CCKTC]: {
        providerName: "Chua Chu Kang Town Council (Main)",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.ECFSTC]: {
        providerName: "East Coast-Fengshan Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.ECTC]: {
        providerName: "East Coast Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.HBPTC]: {
        providerName: "Holland-Bukit Panjang Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.JBTC]: {
        providerName: "Jalan Besar Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.JRTC]: {
        providerName: "Jurong-Clementi Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.JRCTC]: {
        providerName: "Jurong-Clementi Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.MPTC]: {
        providerName: "Marine Parade Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.MYTTC]: {
        providerName: "Marsiling-Yew Tee Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.NSTC]: {
        providerName: "Nee Soon Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.PRPGTC]: {
        providerName: "Pasir Ris-Punggol Town Council (Punggol)",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.SBTC]: {
        providerName: "Sembawang Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.TTC]: {
        providerName: "Tampines Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.TPTC]: {
        providerName: "Tanjong Pagar Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.WCTC]: {
        providerName: "West Coast Town Council (Boon Lay)",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.SKTC]: {
        providerName: "Sengkang Town Council",
        providerType: enum_1.ProviderValue.TOWN_COUNCIL,
        hasM360: true,
    },
    [enum_1.ProviderCode.AVA]: {
        providerName: "Agri-Food & Veterinary Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.BCA]: {
        providerName: "Building and Construction Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.HDB]: {
        providerName: "Housing and Development Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.LTA]: {
        providerName: "Land Transport Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.NEA]: {
        providerName: "National Environment Agency",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.NPARKS]: {
        providerName: "National Parks Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.PA]: {
        providerName: "People's Association",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.PUB]: {
        providerName: "Public Utilities Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.SLA]: {
        providerName: "Singapore Land Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.SPF]: {
        providerName: "Singapore Police Force",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.URA]: {
        providerName: "Urban Redevelopment Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.SFA]: {
        providerName: "Singapore Food Agency",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.COA]: {
        providerName: "Municipal Services Office",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: true,
    },
    [enum_1.ProviderCode.TPIOP]: {
        providerName: "Integrated Operator",
        providerType: enum_1.ProviderValue.OPERATOR,
        hasM360: true,
    },
    [enum_1.ProviderCode.AGC]: {
        providerName: "Attorney-General's Chambers",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.AGO]: {
        providerName: "Auditor-General's Office",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.ASTAR]: {
        providerName: "Agency For Science, Technology And Research",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.BOA]: {
        providerName: "Board Of Architects",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CAAS]: {
        providerName: "Civil Aviation Authority Of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CAB]: {
        providerName: "The Cabinet",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CCCS]: {
        providerName: "Competition and Consumer Commission of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CEA]: {
        providerName: "Council for Estate Agencies",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CNB]: {
        providerName: "Central Narcotics Bureau",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.COLDSTORAGE]: {
        providerName: "Cold Storage",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CPFB]: {
        providerName: "Central Provident Fund Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CPIB]: {
        providerName: "Corrupt Practices Investigation Bureau",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CRA]: {
        providerName: "Casino Regulatory Authority of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.GRA]: {
        providerName: "Gambling Regulatory Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CSC]: {
        providerName: "Civil Service College",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CUSTOMS]: {
        providerName: "Singapore Customs",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.DSTA]: {
        providerName: "Defence Science And Technology Agency",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.EDB]: {
        providerName: "Economic Development Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.ELD]: {
        providerName: "Elections Department",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.EMA]: {
        providerName: "Energy Market Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.ESG]: {
        providerName: "Enterprise Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.GIANT]: {
        providerName: "Giant",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.GovTech]: {
        providerName: "Government Technology Agency",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.HEB]: {
        providerName: "Hindu Endowments Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.HLB]: {
        providerName: "Hotel Licensing Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.HPB]: {
        providerName: "Health Promotion Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.HSA]: {
        providerName: "Health Science Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.IAC]: {
        providerName: "Industrial Arbitration Court",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.ICA]: {
        providerName: "Immigration and Checkpoint Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.IMDA]: {
        providerName: "Info-Communications Media Development Authority",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.IPOS]: {
        providerName: "Intellectual Property Office of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.IRAS]: {
        providerName: "Inland Revenue Authority of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.ISEAS]: {
        providerName: "Institute of Southeast Asian Studies",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.ISTANA]: {
        providerName: "ISTANA",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.ITE]: {
        providerName: "Institute of Technical Education",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.JTC]: {
        providerName: "JTC Corporation",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MAS]: {
        providerName: "Monetary Authority Of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MCCY]: {
        providerName: "Ministry Of Culture, Community And Youth",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MCI]: {
        providerName: "Ministry of Digital Development and Information",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MFA]: {
        providerName: "Ministry of Foreign Affairs",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MHA]: {
        providerName: "Ministry of Home Affairs",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MINDEF]: {
        providerName: "Ministry Of Defence",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MINLAW]: {
        providerName: "Ministry of Law",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MND]: {
        providerName: "Ministry of National Development",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MOE]: {
        providerName: "Ministry of Education",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MOF]: {
        providerName: "Ministry of Finance",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MOH]: {
        providerName: "Ministry of Health",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MOM]: {
        providerName: "Ministry of Manpower",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MOT]: {
        providerName: "Ministry of Transport",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MPA]: {
        providerName: "Maritime And Port Authority Of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MSE]: {
        providerName: "Ministry of Sustainability & the Environment",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MSF]: {
        providerName: "Ministry of Social and Family Development",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MTI]: {
        providerName: "Ministry of Trade and Industry",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MUIS]: {
        providerName: "Majlis Ugama Islam, Singapura",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MUSTAFA]: {
        providerName: "Mustafa",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.NAC]: {
        providerName: "National Arts Council",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.NCSS]: {
        providerName: "National Council Of Social Service",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.NHB]: {
        providerName: "National Heritage Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.NLB]: {
        providerName: "National Library Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.NP]: {
        providerName: "Ngee Ann Polytechnic",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.NTUCFAIRPRICE]: {
        providerName: "NTUC FairPrice",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.NYP]: {
        providerName: "Nanyang Polytechnic",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PAPRISM]: {
        providerName: "People's Association (PA PRISM)",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PARL]: {
        providerName: "Parliament of Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PDPC]: {
        providerName: "Personal Data Protection Commission",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PEB]: {
        providerName: "Professional Engineers Board, Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PMO]: {
        providerName: "Prime Minister's Office",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PSC]: {
        providerName: "Public Service Comission",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PSD]: {
        providerName: "Public Service Division",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.PTC]: {
        providerName: "Public Transport Council",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.RP]: {
        providerName: "Republic Polytechnic",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SAC]: {
        providerName: "Singapore Accountancy Commission",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SCB]: {
        providerName: "Science Centre Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SCDF]: {
        providerName: "Singapore Civil Defence Force",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SCORE]: {
        providerName: "Singapore Corporation Of Rehabilitative Enterprises",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SDC]: {
        providerName: "Singapore Dental Council",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SEAB]: {
        providerName: "Singapore Examinations And Assessment Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SENTOSA]: {
        providerName: "Sentosa Development Corportation",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SHENGSIONG]: {
        providerName: "Sheng Siong",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SLF]: {
        providerName: "Singapore Labour Foundation",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SMC]: {
        providerName: "Singapore Medical Council",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SNB]: {
        providerName: "Singapore Nursing Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SP]: {
        providerName: "Singapore Polytechnic",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SPC]: {
        providerName: "Singapore Pharmacy Council",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SPORTSG]: {
        providerName: "Sport Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SPS]: {
        providerName: "Singapore Prisons Service",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SSG]: {
        providerName: "SkillsFuture Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.STATECOURTS]: {
        providerName: "Judiciary, State Courts",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.STB]: {
        providerName: "Singapore Tourism Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.SUPCOURT]: {
        providerName: "Judiciary, Supreme Court",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.TCMPB]: {
        providerName: "TCM Practitioners Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.TOTEBOARD]: {
        providerName: "Singapore Totalisator Board",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.TP]: {
        providerName: "Temasek Polytechnic",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.WSG]: {
        providerName: "Workforce Singapore",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.CRU]: {
        providerName: "Municipal Services Office",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.HTX]: {
        providerName: "Home Team Science & Technology Agency",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
    [enum_1.ProviderCode.MDDI]: {
        providerName: "Ministry of Digital Development and Information",
        providerType: enum_1.ProviderValue.AGENCY,
        hasM360: false,
    },
};
//# sourceMappingURL=provider-code-info.js.map